import i18next from 'i18next';
import fileDownload from 'js-file-download';
import axios from 'axios';
import cookies from 'js-cookie';
import { message } from 'antd';
import endpoints from '~settings/endpoints';
import { cookieNames } from '~constants';

export const downloadExcelFile = fileName =>
  axios({
    method: 'GET',
    url: endpoints.downloadPartnerCommissionTransferBulkUpdateExcel.url(fileName),
    headers: {
      Authorization: `Bearer ${cookies.get(cookieNames.token)}`,
    },
    responseType: 'blob',
  })
    .then(res => {
      fileDownload(res.data, fileName);
    })
    .catch(err => {
      console.log('download excel file error: ', err);
      message.error(i18next.t('cms.reconciliation.booking.bulk_update_modal.download.error'));
    });
